import { useEffect, useState } from "react";
import { Eye } from "lucide-react";
import ModalBare from "../../../../components/ModalBare";
import useAPI from "../../../../hooks/useAPI";

export default function PreviewModal({ companyData, companyId }) {
  const [showOverlay, setShowOverlay] = useState(false);
  const api = useAPI();

  useEffect(() => {
    if (companyData && Object.keys(companyData).length > 0) {
      sessionStorage.setItem("previewDesignData", JSON.stringify(companyData));
    }
  }, [companyData]);

  useEffect(() => {
    api.getWalletShard()
      .then(() => setShowOverlay(false))
      .catch(() => setShowOverlay(true));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isDev = window.location.hostname.startsWith("dev-") || window.location.hostname === "localhost";
  const walletBaseUrl = isDev
    ? "https://dev-wallet.wallettwo.com"
    : "https://wallet.wallettwo.com";

  const iframeUrl = new URL(`${walletBaseUrl}/action/signature?message="This is a test"`);
  iframeUrl.searchParams.append("companyId", companyId || "");
  iframeUrl.searchParams.append("preview", "true");

  return (
    <ModalBare name="livePreview" title="Live Preview" className="w-full h-full max-w-7xl max-h-[90vh]">
      <div className="relative w-full h-full">
        <iframe
          src={iframeUrl.toString()}
          title="WalletTwo Design Preview"
          className="w-full"
          style={{
            height: "calc(90vh - 120px)",
            border: "none",
            filter: showOverlay ? "blur(6px)" : "none",
            transition: "filter 0.3s ease",
          }}
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        />

        {showOverlay && (
          <div className="absolute inset-0 flex items-center justify-center bg-black/10">
            <div className="bg-white rounded-2xl shadow-xl p-8 mx-6 max-w-sm w-full text-center">
              <div className="flex justify-center mb-4">
                <div className="bg-blue-100 rounded-full p-3">
                  <Eye className="w-6 h-6 text-blue-600" />
                </div>
              </div>
              <h4 className="text-lg font-semibold text-gray-900 mb-2">
                Wallet preview
              </h4>
              <p className="text-sm text-gray-600 mb-6">
                Please create your wallet to activate the preview.
              </p>
              <button
                onClick={() => setShowOverlay(false)}
                className="w-full px-4 py-2.5 bg-blue-600 text-white text-sm font-semibold rounded-xl hover:bg-blue-700 transition-colors cursor-pointer"
              >
                Confirm
              </button>
            </div>
          </div>
        )}
      </div>
    </ModalBare>
  );
}